$(function () {
    var ex = JSON.parse($("#info_extension").val());

    if (ex && ex.blocks && ex.blocks.length > 0) {
        var html = "";

        if (ex.special_new_id) {
            for (var i = 0; i < ex.blocks.length; i++) {
                var info = ex.blocks[i];
                var onlyoneAndnotitle = false
                if (!info.title && ex.blocks.length == 1) {
                    onlyoneAndnotitle = true
                }
                if (info.block_id) {
                    html += '<div class="class' + (onlyoneAndnotitle ? ' notitle' : '') + '"  data-contents="' + info.block_id + '" data-type="' + info.type + '">' + info.title + '</div>';
                }
            }
        } else {
            for (var i = 0; i < ex.blocks.length; i++) {
                var info = ex.blocks[i];
                var onlyoneAndnotitle = false
                if (!info.title && ex.blocks.length == 1) {
                    onlyoneAndnotitle = true
                }
                if (info.content_ids) {
                    html += '<div class="class ' + (onlyoneAndnotitle ? ' notitle' : '') + '" data-contents="' + info.content_ids.toString() + '">' + info.title + '</div>';
                }
                else if (info.videos) {
                    var videos = [];
                    for (var j = 0; j < info.videos.length; j++) {
                        videos.push(info.videos[j].id);
                    }
                    html +=
                        '<div class="class" data-videos="' +
                        videos.toString() +
                        '">' +
                        info.title +
                        "</div>";
                }
            }

        }
        $(".left").html(html);
    }

    $(".left .class").on("click", function () {
        if ($(this).hasClass("selected")) return;

        $(".left .class").removeClass("selected");
        $(this).addClass("selected");

        var id = $(this).data("contents");

        if ($(this).data("contents")) {
            if (ex.special_new_id) {
                var type = $(this).data('type');

                $.ajax({
                    type: 'get',
                    async: false,
                    url: ROOT + '/a/specialNewContent?id=' + ex.special_new_id + '&block_id=' + id,
                    data: null,
                    contentType: 'application/json',
                    dataType: 'json',
                    success: function (res) {
                        if (res !== undefined && res.message !== undefined) {
                            console.log(res);
                            return;
                        }
                        var data = []
                        for (var i = 0; i < res.data.length; i++) {
                            data[i] = res.data[i].data;

                        }
                        // data = data.data.map(item => { return item.data })

                        if (type == "VIDEO") {
                            // data = data.data
                            var newlist = toVideoListHtml(data);
                            $(".middle .list").html(newlist);
                            handleVideoClick()

                        } else {

                            var newlist = toListHtml(data);

                            $('.middle .list').html(newlist);
                        }


                    },
                    error: function (data) {
                        console.log(data);
                    }
                });
            } else {
                $.ajax({
                    type: "get",
                    async: false,
                    url: ROOT + "/a/contents?id=" + id,
                    data: null,
                    contentType: "application/json",
                    dataType: "json",
                    success: function (data) {
                        if (data !== undefined && data.message !== undefined) {
                            console.log(data);
                            return;
                        }

                        var newlist = toListHtml(data);

                        $(".middle .list").html(newlist);
                    },
                    error: function (data) {
                        console.log(data);
                    },
                });
            }
            if ($(this).data("videos")) {
                var id = $(this).data("videos");
                $.ajax({
                    type: "get",
                    async: false,
                    url: ROOT + "/a/video?id=" + id,
                    data: null,
                    contentType: "application/json",
                    dataType: "json",
                    success: function (data) {
                        if (data !== undefined && data.message !== undefined) {
                            console.log(data);
                            return;
                        }
                        var newlist = toVideoListHtml(data);
                        $(".middle .list").html(newlist);
                        // handleVideoClick()
                    },
                    error: function (data) {
                        console.log(data);
                    },
                });
            }
        }
    });
    $(".left .class:first").click();

    var rData = getColumnList("zhuanti", 1, 5);
    if (rData && rData.data && rData.data.length > 0) {
        var html = "";
        for (var i = 0; i < rData.data.length; i++) {
            var info = rData.data[i];
            html +=
                '<div class="newest-item">\n' +
                '        <a href="' +
                info.url +
                '" class="newest-item-img">\n' +
                '            <img src="' +
                info.thumbnail_urls[0] +
                '?w=236&h=132&s=3" />\n' +
                "        </a>\n" +
                '        <a href="' +
                info.url +
                '" class="newest-item-title">' +
                info.title +
                "</a>\n" +
                "    </div>";
        }
        $(".right").html(html);
    }
});
var myVideoPlay = null; //videoJs注册组件
var url = null;
$(".videoDlg-box").on("click", function (e) {
    e.stopPropagation();
});
$(document).on("click", ".videoBtn", function (event) {
    //初始化videoJS
    if (url != $(this).attr("data-videoUrl")) {
        url = $(this).attr("data-videoUrl").split(",");
        var videoImg = $(this).find("img")[0].src.split("?")[0];
        if (myVideoPlay) {
            myVideoPlay.dispose(); //videoJs销毁后会删除相应dom
        }
        var videoConten = "";
        videoConten +=
            '<video id="viewcontent" class="video-js vjs-default-skin" controls    style="min-width: 1200px; min-height: 800px;"preload ="auto" autoplay  poster="';
        videoConten += videoImg;
        videoConten += '">';
        videoConten += "</video>";
        $(".videoDlg .videoDlg-box").html(videoConten);
        myVideoPlay = startPlay(url[0], "viewcontent", true); //注册videoJSs
    } else {
    }
    $(".videoDlg").css("display", "block");
    myVideoPlay.play(0);
});
//点击蒙版关闭播放器
$(".videoDlg").on("click", function (event) {
    if (myVideoPlay) {
        myVideoPlay.pause();
        myVideoPlay.currentTime(0);
    }
    $(".videoDlg").css("display", "none");
    event.stopPropagation();
});
function handleVideoClick() {
    $('.video-item').on("click", ".videoBtn", function (event) {
        event.stopPropagation();
        event.preventDefault();

        //初始化videoJS
        if (url != $(this).attr("data-videoUrl")) {
            url = $(this).attr("data-videoUrl").split(",");
            var videoImg = $(this).find("img")[0].src.split("?")[0];
            if (myVideoPlay) {
                myVideoPlay.dispose(); //videoJs销毁后会删除相应dom
            }
            var videoConten = "";
            videoConten +=
                '<video id="viewcontent" class="video-js vjs-default-skin" controls    style="min-width: 1200px; min-height: 800px;"  poster="';
            videoConten += videoImg;
            videoConten += '">';
            videoConten += "</video>";
            $(".videoDlg .videoDlg-box").html(videoConten);
            myVideoPlay = startPlay(url[0], "viewcontent", true); //注册videoJSs


        } else {
        }
        $(".videoDlg").css("display", "block");
        myVideoPlay.play(0);

    });

}
function toVideoListHtml(data) {
    var videoList = "";
    videoList += '<ul class="video-box">';
    for (var i = 0; i < data.length; i++) {
        var info = data[i];
        var url = [];
        var tmpVideoList = [];
        for (var j = 0; j < info.versions.length; j++) {
            var types = info.versions[j].url.split(".");
            var type = types[types.length - 1];

            if (type == "mp4") {
                url.push(info.versions[j].url);
            } else {
                tmpVideoList.push(info.versions[j].url);
            }
        }
        url = url.concat(tmpVideoList);
        var img = "";
        if (info.cover_url) {
            img = info.cover_url;
        } else {
            img = require("../images/radio/disc.png");
            img = "../../" + img;
        }

        videoList +=
            '<li class="video-item"><div class="video-click videoBtn" data-videoUrl=';
        videoList += '"' + url + '"';
        videoList += ">";
        // videoList+='<img src="'+img+'"  width="186" height="100">'
        videoList +=
            '<img src="' + img + '?w=186&h=100&s=3" alt="" width="186" height="100">';
        videoList += '<p class="ellipsis">' + info.title + "</p>";
        videoList += "</div>";
        videoList += '<div class="duration-box"> ';
        videoList += '<div class="date">';
        videoList += info.modification_time
            ? formatDate(info.modification_time)
            : "";
        videoList += "</div>";
        videoList += '<div class="duration">';
        videoList += info.duration ? getDuration(info.duration) : "";
        videoList += "</div>";
        videoList += "</div>";
        videoList += "</li>";
    }
    videoList += "</ul>";
    return videoList;
}
function toListHtml(data) {
    var newlist = "";
    for (var i = 0; i < data.length; i++) {
        var info = data[i];
        if (!info) {
            continue
        }

        if (
            info.thumbnail_urls === undefined ||
            info.thumbnail_urls == null ||
            info.thumbnail_urls == ""
        )
            info.thumbnail_urls = [];

        var bottominfo = "";
        bottominfo += '<div class="news_info">';
        bottominfo += '<div class="user">' + info.author_nickname + "</div>";
        bottominfo += '<div class="time">' + info.publish_time + "</div>";
        bottominfo += '<div class="reply">';
        if (info.comment_count > 0)
            bottominfo +=
                '<div class="reply_count">' + info.comment_count + "评论</div>";
        if (info.view_count > 0)
            bottominfo +=
                '<div class="reply_count">' + info.view_count + "浏览</div>";
        bottominfo += "</div>";
        if (info.source)
            bottominfo += '<div class="source">来源: ' + info.source + "</div>";
        bottominfo += "</div>";

        newlist += '<div class="newsItem">';
        // 只显示有图和无图两种情况
        if (
            info.list_item_mode == 0 ||
            info.thumbnail_urls.length == 0 ||
            !info.thumbnail_urls[0]
        ) {
            // 无图
            newlist += '<div class="newsInfo">';
            newlist += '<div class="news_body">';
            newlist +=
                '<a class="news_title" href="' +
                info.url +
                '" target="_blank">' +
                info.title +
                "</a>";
            newlist += '<div class="news_content">';
            if (info.summary) newlist += info.summary;
            newlist += "</div>";
            newlist += "</div>";
            newlist += bottominfo;
            newlist += "</div>";
        } else {
            newlist += '<div class="newsPicture">';
            newlist += '<a href="' + info.url + '" target="_blank">';
            newlist +=
                '<img src="' + info.thumbnail_urls[0] + "?w=200&h=150&s=3" + '"/>';
            newlist += "</a>";
            newlist += "</div>";
            newlist += '<div class="newsInfo">';

            newlist += '<div class="news_body">';
            newlist +=
                '<a class="news_title" href="' +
                info.url +
                '" target="_blank">' +
                info.title +
                "</a>";
            newlist += '<div class="news_content">';
            if (info.summary) newlist += info.summary;
            newlist += "</div>";
            newlist += "</div>";
            newlist += bottominfo;
            newlist += "</div>";
        }
        newlist += "</div>";
        newlist += '<div class="dividing-line"></div>';
    }
    return newlist;
}
function getDuration(data) {
    var mm =
        parseInt(data / 60) >= 10 ? parseInt(data / 60) : "0" + parseInt(data / 60);
    var ss = data % 60 >= 10 ? data % 60 : "0" + (data % 60);
    var duration = mm + ":" + ss;
    return duration;
}
function formatDate(inputTime, format) {
    var date = new Date(inputTime * 1000); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    d = d < 10 ? "0" + d : d;
    var h = date.getHours();
    h = h < 10 ? "0" + h : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? "0" + minute : minute;
    second = second < 10 ? "0" + second : second;
    if (format == "mm-dd") {
        return m + "-" + d;
    } else if ("yy-mm-dd") {
        return y + "-" + m + "-" + d;
    } else {
        m = m < 10 ? "0" + m : m;

        return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
    }
}



//////////////////
// WEBPACK FOOTER
// ./cms/client/js/specialinfo.page.js
// module id = 58
// module chunks = 4